import React from 'react';
import { TFunction } from 'i18next';
import { IActivityFeedItem } from './HomeView/AgentActivityLog.types';
import { HomeOutlined } from '@ant-design/icons';
import { BriefcaseIcon } from '../../common/icons/BriefcaseIcon';
import { ActivityIcon } from '../../common/icons/ActivityIcon';

export const POLLING_INTERVAL_MS = 10000;

// Marker class — text nodes only fade-up when this class is on an ancestor,
// letting components opt into the staggered entrance individually.
export const CASCADE_ANIMATE_CLASS = 'ct-cascade-animate';

export const SET_HOME_VIEW_FILTERS = 'SET_HOME_VIEW_FILTERS';
export const SET_MY_WORK_FILTERS = 'SET_MY_WORK_FILTERS';
export const SET_MY_WORK_FILTERS_SEEDED = 'SET_MY_WORK_FILTERS_SEEDED';
export const SET_ACTIVITY_TAB_FILTERS = 'SET_ACTIVITY_TAB_FILTERS';
export const SET_LAST_OPENED_INCIDENT_ID = 'SET_LAST_OPENED_INCIDENT_ID';
export const SET_LAST_CREATED_TICKET_ID = 'SET_LAST_CREATED_TICKET_ID';

// Shared by the row's fade keyframes and the state that drops the class once it has played.
export const CREATED_ROW_HIGHLIGHT_MS = 3000;

export const TIMELINE_COLOR_MAP: Record<IActivityFeedItem['event_type'], string> = {
  task_completed:   'green',
  task_failed:      'red',
  hitl_interrupted: 'orange',
  hitl_resumed:     'blue',
  job_completed:    'green',
};

export const TASKS_VM_PAGE_TYPE = 'agent_fleet_tasks';
export const TASKS_VM_BUCKET = 'tasks';
export const ALL_TASKS_SCOPE = 'all_tasks';

export const TAB_HOME = 'home';
export const TAB_MY_WORK = 'tasks';
export const TAB_ACTIVITY = 'activity';

export const getTabs = (t: TFunction) => [
  { key: TAB_HOME, label: t('overview'), icon: <HomeOutlined /> },
  { key: TAB_MY_WORK, label: t('tasks'), icon: <BriefcaseIcon /> },
  { key: TAB_ACTIVITY, label: t('activity'), icon: <ActivityIcon /> },
];
